import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import Button from "@/components/common/Buttons/Button";
import InstructionItem from "@/components/InstructionItem";
import useNavigationHelpers from "@/hooks/useNavigationHelpers";

export const Route = createFileRoute("/$locale/$partner/_app/_card/device-role-instructions")({
	component: DeviceRoleInstructions,
});

function DeviceRoleInstructions() {
	const { t } = useTranslation();
	const { goToNextStep } = useNavigationHelpers();

	const instructions = {
		"scanner-device": {
			titleKey: "instructions.A “Scanner” smartphone",
			subtitleKey: "instructions.You’ll use this device to scan and run diagnostics.",
		},
		"evaluated-device": {
			titleKey: "instructions.The “Evaluated” smartphone",
			subtitleKey: "instructions.This is the device you want to trade-in.",
		},
	};

	return (
		<div className="flex flex-col h-full text-left sm:text-center pt-10 sm:pt-20 relative">
			<h3 className="whitespace-pre-line my-2 sm:my-4 sm:px-8 leading-tight">
				{t("instructions.You will need two smartphones to run the advanced diagnostics")}
			</h3>
			<div className="w-full overflow-y-auto pb-20">
				{Object.entries(instructions).map(([key, { titleKey, subtitleKey }]) => (
					<InstructionItem
						key={key}
						iconKey={key}
						title={t(titleKey)}
						subtitle={t(subtitleKey)}
					/>
				))}
			</div>
			<div className="absolute bottom-0 pt-8 bg-fixed-buttons w-full justify-center flex">
				<Button
					label={t("btn.Got it! I am ready")}
					onClick={() => goToNextStep()}
				/>
			</div>
		</div>
	);
}
